module.exports = __webpack_public_path__ + "static/media/cu06_ch02.b5ae983e.png";